module.exports = __webpack_public_path__ + "static/media/personal.1f0dddc5.svg";